// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* ChainApis.module.css
   Only classes used by ChainApis.jsx (list view + split-pane modal).
   Shared atoms now live in shared.module.css. */

.ChainApis_container__M6OeX {
  padding: 20px 0px;
  font-family: system-ui, sans-serif;
  min-height: 700px;
}

/* ── Header / list ─────────────────────────────────────── */
.ChainApis_header__kDhl3 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  flex-direction: column;
  align-items: center;
}

.ChainApis_headerSection__sCIzz {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}

.ChainApis_title__05-aA {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  color: var(--dark-color);
}

.ChainApis_subtitle__eCZAt {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 8px;
}

.ChainApis_createButton__5QeG1 {
  background: var(--primary);
  color: var(--white-color);
  border: none;
  padding: 0.7rem 1.4rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  white-space: nowrap;
}

.ChainApis_createButton__5QeG1:hover { background: var(--primary-hover); }

.ChainApis_emptyState__SB3Wc {
  text-align: center;
  padding: 4rem 0;
  color: #888;
  font-size: 1.1rem;
}

.ChainApis_list__0BAq3 { display: flex; flex-direction: column; gap: 1rem; }

.ChainApis_chainCard__vlC7- {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ChainApis_chainCardHeader__obvrF {
  display: flex;
  margin-bottom: 1rem;
  flex-direction: column-reverse;
}

.ChainApis_chainInfo__D3vk3 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.ChainApis_chainName__RlIqW { margin: 0; font-size: 1.2rem; font-weight: 600; }
.ChainApis_badges__wVIbW { display: flex; gap: 0.5rem; }

.ChainApis_stepBadge__qt7eu {
  background: #eff6ff;
  color: #1e40af;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
}

.ChainApis_actions__sJKCY {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}

/* ── View toggle ──────────────────────────────────────── */
.ChainApis_headerActions__n1-8n { display: flex; align-items: center; gap: 16px; }

.ChainApis_viewToggle__IOUPh {
  display: flex;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  gap: 2px;
}

.ChainApis_viewToggleBtn__ifeGi {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
  font-size: 14px;
}

.ChainApis_viewToggleBtn__ifeGi:hover { background: rgba(0, 0, 0, 0.05); }

.ChainApis_viewToggleBtn__ifeGi.ChainApis_active__7uDgQ {
  background: white;
  color: #1a73e8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* ── Modal shell ─────────────────────────────────────── */
.ChainApis_overlay__4gbgJ {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Base modal shell. Used by any modal in this component that does not
   opt into \`.modalWide\`. Caps at 90vh so a tall modal never spills off
   the viewport on a short screen. */
.ChainApis_modal__EWkCW {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Chain editor modal. Fills 95% of the viewport in both dimensions,
   capped at 1400px wide. Must appear AFTER \`.modal\` so the equal-
   specificity override wins; the explicit \`height\` (not just
   \`max-height\`) is what forces the browser to actually allocate the
   space — a flex item inside a centered overlay collapses to content
   height when only \`max-height\` is set. */
.ChainApis_modalWide__nlWtg {
  width: 95vw;
  max-width: 1400px;
  height: 95vh;
  max-height: 95vh;
    align-self: center;  /* ensures the flex item does not stretch */

}

.ChainApis_modalHeader__Upfl8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.ChainApis_modalHeader__Upfl8 h3 { margin: 0; font-size: 1.3rem; }

.ChainApis_closeBtn__zaTR1 {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
}

.ChainApis_modalHeaderBar__dibe\\+ {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.ChainApis_modalHeaderTop__Yq3iY { display: flex; align-items: center; gap: 12px; }

.ChainApis_modalHeaderTitle__0RXcE {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #1a1a2e;
}

.ChainApis_modalHeaderSpacer__i2te- { flex: 1 1; }

.ChainApis_chainNameInput__lUoIF {
  padding: 0.4rem 0.6rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 0.9rem;
  min-width: 220px;
}

.ChainApis_chainEnabledToggle__y8vxI {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #4a5568;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ChainApis_chainEnabledToggle__y8vxI input { cursor: pointer; }

.ChainApis_modalBodySplit__tasWj {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.ChainApis_modalFooter__snZGn {
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.ChainApis_cancelBtn__swgq6 {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  cursor: pointer;
}

.ChainApis_saveBtn__nglMy {
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.6rem 1.4rem;
  border-radius: 6px;
  cursor: pointer;
}

.ChainApis_saveBtn__nglMy:hover { background: #1d4ed8; }

/* ── Left pane: tree ─────────────────────────────────── */
.ChainApis_treePane__DwCcm {
  width: 320px;
  flex: 0 0 320px;
  border-right: 1px solid #e2e8f0;
  overflow-y: auto;
  padding: 12px 8px 24px;
  background: #fbfcfe;
}

.ChainApis_treePaneTitle__scG3I {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #718096;
  padding: 4px 10px 8px;
}

.ChainApis_treeRoot__X8zNF { list-style: none; margin: 0; padding: 0; }

.ChainApis_treeChildren__mLc1\\+ {
  list-style: none;
  margin: 0;
  padding: 0 0 0 14px;
  border-left: 1px dashed #cbd5e0;
  margin-left: 14px;
}

.ChainApis_treeRow__2Z4m0 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 13px;
  color: #2d3748;
  transition: background 0.12s ease;
  position: relative;
}

.ChainApis_treeRow__2Z4m0:hover { background: #edf2f7; }
.ChainApis_treeRowSelected__JZNS0 { background: #e8f0fe; color: #1a3d7c; }

.ChainApis_treeRowSelected__JZNS0::before {
  content: "";
  position: absolute;
  left: 0; top: 4px; bottom: 4px;
  width: 3px;
  border-radius: 2px;
  background: #1a73e8;
}

.ChainApis_treeRowEdgeActive__slx4C {
  background: #eef4ff;
  box-shadow: inset 0 0 0 1px #93b4e8;
}

.ChainApis_treeRowLabel__434kj {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ChainApis_treeRowLabelRoot__2UqtH { font-weight: 600; color: #1a1a2e; }
.ChainApis_treeRowUnset__Lv709 { font-style: italic; color: #a0aec0; }

.ChainApis_treeRowChevronBtn__3-hU3 {
  flex: 0 0 auto;
  background: none;
  border: none;
  padding: 2px;
  color: #a0aec0;
  cursor: pointer;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ChainApis_treeRowChevronBtn__3-hU3:hover { color: #4a5568; background: rgba(0, 0, 0, 0.05); }

.ChainApis_treeRowUrlTail__7BE1X,
.ChainApis_treeRowUrlFull__4dVei {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12px;
}

.ChainApis_treeRowUrlFull__4dVei { cursor: help; }

.ChainApis_treeLegend__-CRVe {
  margin-top: 12px;
  padding: 10px 12px;
  border-top: 1px dashed #e2e8f0;
  font-size: 11px;
  color: #718096;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ChainApis_treeLegendRow__\\+ckCY { display: flex; align-items: center; gap: 8px; }

.ChainApis_treeEmptyHint__EiBYD {
  font-size: 12px;
  color: #a0aec0;
  font-style: italic;
  padding: 8px 10px;
}

/* ── Right pane: detail ──────────────────────────────── */
.ChainApis_detailPane__shN5U {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px 32px;
  min-width: 0;
}

.ChainApis_breadcrumb__bBR9S {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12px;
  color: #4a5568;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf2f7;
}

.ChainApis_breadcrumbCrumb__2tmVz {
  padding: 2px 8px;
  border-radius: 4px;
  background: #f7fafc;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  color: #2d3748;
  cursor: pointer;
  border: none;
  font-size: 11.5px;
}

.ChainApis_breadcrumbCrumb__2tmVz:hover { background: #edf2f7; }

.ChainApis_breadcrumbCrumbCurrent__VEgEW {
  background: #e8f0fe;
  color: #1a4fa0;
  font-weight: 600;
  cursor: default;
}

.ChainApis_breadcrumbSep__X1tLk { color: #cbd5e0; font-size: 11px; }

.ChainApis_detailSection__P09M8 { margin-bottom: 20px; }

.ChainApis_detailSectionHeader__987C4 {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #718096;
  margin-bottom: 8px;
}

.ChainApis_detailNodeCard__7gvJI {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px;
  background: #fff;
}

.ChainApis_detailNodeCardManual__GdL2j { border-color: #f6ad55; background: #fffaf0; }
.ChainApis_detailNodeCardRoot__pfQtN { border-left: 3px solid #1a73e8; }

.ChainApis_branchList__uXL6H { display: flex; flex-direction: column; gap: 6px; }

.ChainApis_branchRow__pKHhh {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ChainApis_branchRow__pKHhh:hover {
  border-color: #93b4e8;
  box-shadow: 0 1px 4px rgba(26, 115, 232, 0.08);
}

.ChainApis_branchRowSelected__aHCt9 {
  border-color: #1a73e8;
  background: #f8fbff;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.12);
}

.ChainApis_branchRowBody__KWBnQ {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ChainApis_branchRowTop__KKwQJ { display: flex; align-items: center; gap: 8px; }

.ChainApis_branchRowBottom__I\\+7I4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #4a5568;
}

.ChainApis_branchRowUrl__SEk10 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12px;
}

.ChainApis_branchRowUnset__RL380 { font-style: italic; color: #a0aec0; }

.ChainApis_branchRowMappingBadge__r1vnK {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  background: #edf2f7;
  color: #4a5568;
  white-space: nowrap;
}

.ChainApis_branchRowMappingBadge__r1vnK.ChainApis_warn__Hb62i {
  background: #fff8e1;
  color: #8a6d00;
  border: 1px solid #ffe082;
}

.ChainApis_branchRowDeleteBtn__sTMYy {
  flex: 0 0 auto;
  background: none;
  border: none;
  color: #cbd5e0;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}

.ChainApis_branchRowDeleteBtn__sTMYy:hover { background: #fce8e6; color: #c5221f; }

.ChainApis_edgeHeader__Qpe81 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.ChainApis_edgeHeaderLabel__0g4Xf { font-size: 12px; color: #4a5568; }

.ChainApis_edgeHeaderUrl__MTs2l {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12.5px;
  font-weight: 600;
  color: #1a1a2e;
}

.ChainApis_edgeMappingWrap__GkDgb {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  background: #fff;
}

.ChainApis_edgeBackBtn__8aOca {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #1a73e8;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;
  margin-bottom: 8px;
}

.ChainApis_edgeBackBtn__8aOca:hover { text-decoration: underline; }

.ChainApis_emptyDetailState__aMqTo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #a0aec0;
  font-size: 13px;
  font-style: italic;
}

/* ── Small form groups used in node detail ── */
.ChainApis_formGroup__i696p { margin-bottom: 1.2rem; }

.ChainApis_formGroup__i696p label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.3rem;
  font-size: 0.9rem;
}

.ChainApis_selectedInfo__Hgj6s {
  margin-top: 0.4rem;
  display: flex;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #555;
}

.ChainApis_methodTag__EQX1M {
  background: #e2e8f0;
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  font-weight: 600;
}
.ChainApis_progressPass__OykS2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ChainApis_progressPassLabel__DSUj8 {
  font-weight: 600;
  color: #2d3748;
}

.ChainApis_progressPassCount__6gJfd {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  padding: 2px 8px;
  border-radius: 10px;
  background: #edf2f7;
  color: #4a5568;
  font-size: 11px;
  font-weight: 600;
}

.ChainApis_progressPassCount__6gJfd.ChainApis_done__qTWhu {
  background: #e6f4ea;
  color: #1e7e34;
}

.ChainApis_progressPassCount__6gJfd.ChainApis_partial__QStHE {
  background: #fff8e1;
  color: #8a6d00;
  border: 1px solid #ffe082;
}

.ChainApis_progressPassCount__6gJfd.ChainApis_pending__FYXLK {
  background: #fce8e6;
  color: #c5221f;
}

.ChainApis_progressDivider__zEHQO {
  color: #cbd5e0;
}

.ChainApis_progressHint__O3jv6 {
  margin-left: auto;
  font-size: 12px;
  color: #718096;
  font-style: italic;
}

/* ── Node "next step" CTA bar ─────────────────────────────── */

.ChainApis_nodeNextBar__1mo5r {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ebf8ff;
  border: 1px solid #bee3f8;
  margin-top: 14px;
  font-size: 12.5px;
  color: #2a4365;
}

.ChainApis_nodeNextBar__1mo5r.ChainApis_warn__Hb62i {
  background: #fff8e1;
  border-color: #ffe082;
  color: #744210;
}

.ChainApis_nodeNextBtn__Pt2yK {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.ChainApis_nodeNextBtn__Pt2yK:hover {
  background: #1557b0;
}

/* ── Edge "next incomplete" bar ───────────────────────────── */

.ChainApis_edgeNextBar__JPj5k {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding: 12px 14px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ChainApis_edgeNextLabel__45ANA {
  font-size: 12.5px;
  color: #4a5568;
}

.ChainApis_edgeNextBtn__RxHZJ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.ChainApis_edgeNextBtn__RxHZJ:hover {
  background: #1557b0;
}

.ChainApis_edgeNextBtn__RxHZJ:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.ChainApis_edgeDoneBadge__wo62o {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #1e7e34;
  background: #e6f4ea;
  padding: 4px 10px;
  border-radius: 12px;
}

/* ── Info callouts ────────────────────────────────────────── */

.ChainApis_infoCallout__DRBGj {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  margin-bottom: 12px;
}

.ChainApis_infoCallout__DRBGj.ChainApis_info__UftIh {
  background: #ebf8ff;
  border: 1px solid #bee3f8;
  color: #2a4365;
}

.ChainApis_infoCallout__DRBGj.ChainApis_warn__Hb62i {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #744210;
}

.ChainApis_infoCalloutIcon__wf6\\+c {
  flex: 0 0 auto;
  margin-top: 1px;
}

/* ── Manual node styling ──────────────────────────────────── */

.ChainApis_canvasNodeManual__2QDEL {
  border: 1px solid #f6ad55 !important;
  background: #fffaf0 !important;
}

.ChainApis_manualBadge__v-E4V {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  color: #744210;
  background: #fefcbf;
  border: 1px solid #f6ad55;
  border-radius: 10px;
  vertical-align: middle;
}

.ChainApis_canvasManualToggle__sMBs9 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 10px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ChainApis_canvasManualToggle__sMBs9 input {
  margin: 0;
  cursor: pointer;
}

.ChainApis_canvasManualToggle__sMBs9:hover {
  background: #edf2f7;
}

.ChainApis_canvasManualHint__17SEf {
  margin-top: 6px;
  padding: 8px 10px;
  background: #fff8e1;
  border: 1px solid #ffd54f;
  border-radius: 4px;
  font-size: 11px;
  color: #5d4037;
  line-height: 1.5;
}

.ChainApis_canvasManualHint__17SEf code {
  background: #ffffff88;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 10px;
}

/* ── Canvas node bits that are still shared (icons, url, meta) ── */

.ChainApis_canvasNodeMethod__\\+kpyU {
  display: inline-block;
  padding: 2px 10px;
  background: #e8f0fe;
  color: #1a73e8;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
}

.ChainApis_canvasNodeUrl__-w\\+hp {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
  word-break: break-all;
}

.ChainApis_canvasNodeLabel__1RL\\+u {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.ChainApis_canvasNodeSub__kckyn {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.ChainApis_canvasNodeMeta__bMKgk {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
}

.ChainApis_canvasNodeMeta__bMKgk > span {
  font-size: 12px;
  color: #666;
  display: block;
  margin-bottom: 4px;
}

.ChainApis_canvasNodeDataList__HzKUP {
  margin: 4px 0 0 0;
  padding-left: 0;
  list-style: none;
  font-size: 12px;
  color: #555;
}

.ChainApis_canvasNodeDataList__HzKUP li {
  margin: 2px 0;
  padding: 2px 8px;
  background: #f0f4ff;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
}

.ChainApis_canvasNodeEmptyData__eJqcb {
  font-size: 12px;
  color: #999;
  font-style: italic;
}

.ChainApis_canvasNodeStatus__sFmZz {
  font-size: 14px;
  font-weight: 600;
  color: #34a853;
  margin-left: auto;
}

.ChainApis_startIcon__6\\+U0S {
  color: #34a853;
  font-size: 16px;
  margin-right: 8px;
}

.ChainApis_successIcon__9G93P {
  color: #34a853;
  font-size: 14px;
  margin-right: 4px;
}

.ChainApis_errorIcon__pR5u5 {
  color: #ea4335;
  font-size: 14px;
  margin-right: 4px;
}

.ChainApis_canvasArrow__1m0df {
  flex: 0 0 auto;
  color: #ccc;
  font-size: 20px;
  align-self: center;
}

.ChainApis_workflowBadge__mgD-G {
  display: inline-block;
  padding: 2px 10px;
  background: #e8f0fe;
  color: #1a73e8;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  text-align: center;
}

.ChainApis_canvasNameInput__kW8yD {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  border: 2px solid transparent;
  background: transparent;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s;
  min-width: 200px;
}

.ChainApis_canvasNameInput__kW8yD:hover {
  border-color: #e8e8e8;
  background: white;
}

.ChainApis_canvasNameInput__kW8yD:focus {
  outline: none;
  border-color: #1a73e8;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.ChainApis_canvasToggle__LEMoD {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ChainApis_canvasToggle__LEMoD input[type="checkbox"] {
  width: 40px;
  height: 22px;
  appearance: none;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.ChainApis_canvasToggle__LEMoD input[type="checkbox"]:checked {
  background: #34a853;
}

.ChainApis_canvasToggle__LEMoD input[type="checkbox"]::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: transform 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.ChainApis_canvasToggle__LEMoD input[type="checkbox"]:checked::before {
  transform: translateX(18px);
}

.ChainApis_canvasSelect__W7NVA {
  padding: 6px 32px 6px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 12px;
  background: white;
  color: #333;
  cursor: pointer;
  appearance: none;
  min-width: 180px;
  transition: all 0.2s;
}

.ChainApis_canvasSelect__W7NVA:hover {
  border-color: #1a73e8;
}

.ChainApis_canvasSelect__W7NVA:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.ChainApis_deleteBranchBtn__VoNNL {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  margin-left: auto;
  margin-right: 0.5rem;
}

.ChainApis_deleteBranchBtn__VoNNL:hover {
  background: #fce8e6;
  color: #d93025;
}

.ChainApis_saveButton__LNLag {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ChainApis_saveButton__LNLag:hover {
  background: #1557b0;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}

.ChainApis_cancelButton__C2BUg {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f1f3f4;
  color: #5f6368;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ChainApis_cancelButton__C2BUg:hover {
  background: #e8eaed;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ChainApis.module.css"],"names":[],"mappings":";;AAEA;;gDAEgD;;AAEhD;EACE,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA,uCAAsB,gCAAgC,EAAE;;AAExD;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,yBAAQ,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE1D;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8BAAa,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7D,2BAAU,aAAa,EAAE,WAAW,EAAE;;AAEtC;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D,kCAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA,wCAAuB,+BAA+B,EAAE;;AAExD;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;oCAEoC;AACpC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;0CAK0C;AAC1C;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;IACd,kBAAkB,GAAG,2CAA2C;;AAEpE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,mCAAkB,SAAS,EAAE,iBAAiB,EAAE;;AAEhD;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,mCAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEjE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAqB,SAAO,EAAE;;AAE9B;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,6CAA4B,eAAe,EAAE;;AAE7C;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kCAAiB,mBAAmB,EAAE;;AAEtC,2DAA2D;AAC3D;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA,6BAAY,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAErD;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,kCAAiB,mBAAmB,EAAE;AACtC,oCAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qCAAoB,gBAAgB,EAAE,cAAc,EAAE;AACtD,iCAAgB,kBAAkB,EAAE,cAAc,EAAE;;AAEpD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4CAA2B,cAAc,EAAE,+BAA+B,EAAE;;AAE5E;;EAEE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;AACjB;;AAEA,mCAAkB,YAAY,EAAE;;AAEhC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,mCAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE/D;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0CAAyB,mBAAmB,EAAE;;AAE9C;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAiB,cAAc,EAAE,eAAe,EAAE;;AAElD,kCAAiB,mBAAmB,EAAE;;AAEtC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,yCAAwB,qBAAqB,EAAE,mBAAmB,EAAE;AACpE,uCAAsB,8BAA8B,EAAE;;AAEtD,+BAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iCAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;AACjB;;AAEA,mCAAkB,kBAAkB,EAAE,cAAc,EAAE;;AAEtD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oCAAmB,eAAe,EAAE,cAAc,EAAE;;AAEpD;EACE,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAqB,0BAA0B,EAAE;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD,8BAAa,qBAAqB,EAAE;;AAEpC;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gEAAgE;;AAEhE;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,oEAAoE;;AAEpE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["\n\n/* ChainApis.module.css\n   Only classes used by ChainApis.jsx (list view + split-pane modal).\n   Shared atoms now live in shared.module.css. */\n\n.container {\n  padding: 20px 0px;\n  font-family: system-ui, sans-serif;\n  min-height: 700px;\n}\n\n/* ── Header / list ─────────────────────────────────────── */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n  flex-direction: column;\n  align-items: center;\n}\n\n.headerSection {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  color: var(--dark-color);\n}\n\n.subtitle {\n  color: #6c757d;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin-top: 8px;\n}\n\n.createButton {\n  background: var(--primary);\n  color: var(--white-color);\n  border: none;\n  padding: 0.7rem 1.4rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.createButton:hover { background: var(--primary-hover); }\n\n.emptyState {\n  text-align: center;\n  padding: 4rem 0;\n  color: #888;\n  font-size: 1.1rem;\n}\n\n.list { display: flex; flex-direction: column; gap: 1rem; }\n\n.chainCard {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 1.2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.chainCardHeader {\n  display: flex;\n  margin-bottom: 1rem;\n  flex-direction: column-reverse;\n}\n\n.chainInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.chainName { margin: 0; font-size: 1.2rem; font-weight: 600; }\n.badges { display: flex; gap: 0.5rem; }\n\n.stepBadge {\n  background: #eff6ff;\n  color: #1e40af;\n  padding: 0.5rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* ── View toggle ──────────────────────────────────────── */\n.headerActions { display: flex; align-items: center; gap: 16px; }\n\n.viewToggle {\n  display: flex;\n  background: #f0f0f0;\n  border-radius: 8px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.viewToggleBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #666;\n  transition: all 0.2s;\n  font-size: 14px;\n}\n\n.viewToggleBtn:hover { background: rgba(0, 0, 0, 0.05); }\n\n.viewToggleBtn.active {\n  background: white;\n  color: #1a73e8;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* ── Modal shell ─────────────────────────────────────── */\n.overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Base modal shell. Used by any modal in this component that does not\n   opt into `.modalWide`. Caps at 90vh so a tall modal never spills off\n   the viewport on a short screen. */\n.modal {\n  background: white;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Chain editor modal. Fills 95% of the viewport in both dimensions,\n   capped at 1400px wide. Must appear AFTER `.modal` so the equal-\n   specificity override wins; the explicit `height` (not just\n   `max-height`) is what forces the browser to actually allocate the\n   space — a flex item inside a centered overlay collapses to content\n   height when only `max-height` is set. */\n.modalWide {\n  width: 95vw;\n  max-width: 1400px;\n  height: 95vh;\n  max-height: 95vh;\n    align-self: center;  /* ensures the flex item does not stretch */\n\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.2rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modalHeader h3 { margin: 0; font-size: 1.3rem; }\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #888;\n}\n\n.modalHeaderBar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modalHeaderTop { display: flex; align-items: center; gap: 12px; }\n\n.modalHeaderTitle {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.modalHeaderSpacer { flex: 1; }\n\n.chainNameInput {\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  min-width: 220px;\n}\n\n.chainEnabledToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: #4a5568;\n  cursor: pointer;\n  user-select: none;\n}\n\n.chainEnabledToggle input { cursor: pointer; }\n\n.modalBodySplit {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.8rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.cancelBtn {\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  padding: 0.6rem 1.2rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.saveBtn {\n  background: #2563eb;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.4rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.saveBtn:hover { background: #1d4ed8; }\n\n/* ── Left pane: tree ─────────────────────────────────── */\n.treePane {\n  width: 320px;\n  flex: 0 0 320px;\n  border-right: 1px solid #e2e8f0;\n  overflow-y: auto;\n  padding: 12px 8px 24px;\n  background: #fbfcfe;\n}\n\n.treePaneTitle {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #718096;\n  padding: 4px 10px 8px;\n}\n\n.treeRoot { list-style: none; margin: 0; padding: 0; }\n\n.treeChildren {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 0 14px;\n  border-left: 1px dashed #cbd5e0;\n  margin-left: 14px;\n}\n\n.treeRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 13px;\n  color: #2d3748;\n  transition: background 0.12s ease;\n  position: relative;\n}\n\n.treeRow:hover { background: #edf2f7; }\n.treeRowSelected { background: #e8f0fe; color: #1a3d7c; }\n\n.treeRowSelected::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 4px; bottom: 4px;\n  width: 3px;\n  border-radius: 2px;\n  background: #1a73e8;\n}\n\n.treeRowEdgeActive {\n  background: #eef4ff;\n  box-shadow: inset 0 0 0 1px #93b4e8;\n}\n\n.treeRowLabel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.treeRowLabelRoot { font-weight: 600; color: #1a1a2e; }\n.treeRowUnset { font-style: italic; color: #a0aec0; }\n\n.treeRowChevronBtn {\n  flex: 0 0 auto;\n  background: none;\n  border: none;\n  padding: 2px;\n  color: #a0aec0;\n  cursor: pointer;\n  border-radius: 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.treeRowChevronBtn:hover { color: #4a5568; background: rgba(0, 0, 0, 0.05); }\n\n.treeRowUrlTail,\n.treeRowUrlFull {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12px;\n}\n\n.treeRowUrlFull { cursor: help; }\n\n.treeLegend {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-top: 1px dashed #e2e8f0;\n  font-size: 11px;\n  color: #718096;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.treeLegendRow { display: flex; align-items: center; gap: 8px; }\n\n.treeEmptyHint {\n  font-size: 12px;\n  color: #a0aec0;\n  font-style: italic;\n  padding: 8px 10px;\n}\n\n/* ── Right pane: detail ──────────────────────────────── */\n.detailPane {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px 32px;\n  min-width: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-size: 12px;\n  color: #4a5568;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.breadcrumbCrumb {\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #f7fafc;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  color: #2d3748;\n  cursor: pointer;\n  border: none;\n  font-size: 11.5px;\n}\n\n.breadcrumbCrumb:hover { background: #edf2f7; }\n\n.breadcrumbCrumbCurrent {\n  background: #e8f0fe;\n  color: #1a4fa0;\n  font-weight: 600;\n  cursor: default;\n}\n\n.breadcrumbSep { color: #cbd5e0; font-size: 11px; }\n\n.detailSection { margin-bottom: 20px; }\n\n.detailSectionHeader {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #718096;\n  margin-bottom: 8px;\n}\n\n.detailNodeCard {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 14px;\n  background: #fff;\n}\n\n.detailNodeCardManual { border-color: #f6ad55; background: #fffaf0; }\n.detailNodeCardRoot { border-left: 3px solid #1a73e8; }\n\n.branchList { display: flex; flex-direction: column; gap: 6px; }\n\n.branchRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.branchRow:hover {\n  border-color: #93b4e8;\n  box-shadow: 0 1px 4px rgba(26, 115, 232, 0.08);\n}\n\n.branchRowSelected {\n  border-color: #1a73e8;\n  background: #f8fbff;\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.12);\n}\n\n.branchRowBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.branchRowTop { display: flex; align-items: center; gap: 8px; }\n\n.branchRowBottom {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #4a5568;\n}\n\n.branchRowUrl {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12px;\n}\n\n.branchRowUnset { font-style: italic; color: #a0aec0; }\n\n.branchRowMappingBadge {\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #edf2f7;\n  color: #4a5568;\n  white-space: nowrap;\n}\n\n.branchRowMappingBadge.warn {\n  background: #fff8e1;\n  color: #8a6d00;\n  border: 1px solid #ffe082;\n}\n\n.branchRowDeleteBtn {\n  flex: 0 0 auto;\n  background: none;\n  border: none;\n  color: #cbd5e0;\n  padding: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.branchRowDeleteBtn:hover { background: #fce8e6; color: #c5221f; }\n\n.edgeHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.edgeHeaderLabel { font-size: 12px; color: #4a5568; }\n\n.edgeHeaderUrl {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.edgeMappingWrap {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 14px 16px;\n  background: #fff;\n}\n\n.edgeBackBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: #1a73e8;\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 0;\n  margin-bottom: 8px;\n}\n\n.edgeBackBtn:hover { text-decoration: underline; }\n\n.emptyDetailState {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #a0aec0;\n  font-size: 13px;\n  font-style: italic;\n}\n\n/* ── Small form groups used in node detail ── */\n.formGroup { margin-bottom: 1.2rem; }\n\n.formGroup label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n  font-size: 0.9rem;\n}\n\n.selectedInfo {\n  margin-top: 0.4rem;\n  display: flex;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #555;\n}\n\n.methodTag {\n  background: #e2e8f0;\n  padding: 0.1rem 0.4rem;\n  border-radius: 4px;\n  font-weight: 600;\n}\n.progressPass {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.progressPassLabel {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.progressPassCount {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #edf2f7;\n  color: #4a5568;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.progressPassCount.done {\n  background: #e6f4ea;\n  color: #1e7e34;\n}\n\n.progressPassCount.partial {\n  background: #fff8e1;\n  color: #8a6d00;\n  border: 1px solid #ffe082;\n}\n\n.progressPassCount.pending {\n  background: #fce8e6;\n  color: #c5221f;\n}\n\n.progressDivider {\n  color: #cbd5e0;\n}\n\n.progressHint {\n  margin-left: auto;\n  font-size: 12px;\n  color: #718096;\n  font-style: italic;\n}\n\n/* ── Node \"next step\" CTA bar ─────────────────────────────── */\n\n.nodeNextBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #ebf8ff;\n  border: 1px solid #bee3f8;\n  margin-top: 14px;\n  font-size: 12.5px;\n  color: #2a4365;\n}\n\n.nodeNextBar.warn {\n  background: #fff8e1;\n  border-color: #ffe082;\n  color: #744210;\n}\n\n.nodeNextBtn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.nodeNextBtn:hover {\n  background: #1557b0;\n}\n\n/* ── Edge \"next incomplete\" bar ───────────────────────────── */\n\n.edgeNextBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 18px;\n  padding: 12px 14px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.edgeNextLabel {\n  font-size: 12.5px;\n  color: #4a5568;\n}\n\n.edgeNextBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.edgeNextBtn:hover {\n  background: #1557b0;\n}\n\n.edgeNextBtn:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n.edgeDoneBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e7e34;\n  background: #e6f4ea;\n  padding: 4px 10px;\n  border-radius: 12px;\n}\n\n/* ── Info callouts ────────────────────────────────────────── */\n\n.infoCallout {\n  display: flex;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.infoCallout.info {\n  background: #ebf8ff;\n  border: 1px solid #bee3f8;\n  color: #2a4365;\n}\n\n.infoCallout.warn {\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  color: #744210;\n}\n\n.infoCalloutIcon {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\n/* ── Manual node styling ──────────────────────────────────── */\n\n.canvasNodeManual {\n  border: 1px solid #f6ad55 !important;\n  background: #fffaf0 !important;\n}\n\n.manualBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 8px;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #744210;\n  background: #fefcbf;\n  border: 1px solid #f6ad55;\n  border-radius: 10px;\n  vertical-align: middle;\n}\n\n.canvasManualToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.canvasManualToggle input {\n  margin: 0;\n  cursor: pointer;\n}\n\n.canvasManualToggle:hover {\n  background: #edf2f7;\n}\n\n.canvasManualHint {\n  margin-top: 6px;\n  padding: 8px 10px;\n  background: #fff8e1;\n  border: 1px solid #ffd54f;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #5d4037;\n  line-height: 1.5;\n}\n\n.canvasManualHint code {\n  background: #ffffff88;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-family: monospace;\n  font-size: 10px;\n}\n\n/* ── Canvas node bits that are still shared (icons, url, meta) ── */\n\n.canvasNodeMethod {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.canvasNodeUrl {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n  margin-bottom: 8px;\n  word-break: break-all;\n}\n\n.canvasNodeLabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.canvasNodeSub {\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.canvasNodeMeta {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e8e8e8;\n}\n\n.canvasNodeMeta > span {\n  font-size: 12px;\n  color: #666;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.canvasNodeDataList {\n  margin: 4px 0 0 0;\n  padding-left: 0;\n  list-style: none;\n  font-size: 12px;\n  color: #555;\n}\n\n.canvasNodeDataList li {\n  margin: 2px 0;\n  padding: 2px 8px;\n  background: #f0f4ff;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.canvasNodeEmptyData {\n  font-size: 12px;\n  color: #999;\n  font-style: italic;\n}\n\n.canvasNodeStatus {\n  font-size: 14px;\n  font-weight: 600;\n  color: #34a853;\n  margin-left: auto;\n}\n\n.startIcon {\n  color: #34a853;\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n.successIcon {\n  color: #34a853;\n  font-size: 14px;\n  margin-right: 4px;\n}\n\n.errorIcon {\n  color: #ea4335;\n  font-size: 14px;\n  margin-right: 4px;\n}\n\n.canvasArrow {\n  flex: 0 0 auto;\n  color: #ccc;\n  font-size: 20px;\n  align-self: center;\n}\n\n.workflowBadge {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 12px;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.canvasNameInput {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a2e;\n  border: 2px solid transparent;\n  background: transparent;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  min-width: 200px;\n}\n\n.canvasNameInput:hover {\n  border-color: #e8e8e8;\n  background: white;\n}\n\n.canvasNameInput:focus {\n  outline: none;\n  border-color: #1a73e8;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.canvasToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n.canvasToggle input[type=\"checkbox\"] {\n  width: 40px;\n  height: 22px;\n  appearance: none;\n  background: #ccc;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.canvasToggle input[type=\"checkbox\"]:checked {\n  background: #34a853;\n}\n\n.canvasToggle input[type=\"checkbox\"]::before {\n  content: \"\";\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: white;\n  border-radius: 50%;\n  top: 2px;\n  left: 2px;\n  transition: transform 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.canvasToggle input[type=\"checkbox\"]:checked::before {\n  transform: translateX(18px);\n}\n\n.canvasSelect {\n  padding: 6px 32px 6px 12px;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  font-size: 12px;\n  background: white;\n  color: #333;\n  cursor: pointer;\n  appearance: none;\n  min-width: 180px;\n  transition: all 0.2s;\n}\n\n.canvasSelect:hover {\n  border-color: #1a73e8;\n}\n\n.canvasSelect:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.deleteBranchBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: transparent;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n  margin-left: auto;\n  margin-right: 0.5rem;\n}\n\n.deleteBranchBtn:hover {\n  background: #fce8e6;\n  color: #d93025;\n}\n\n.saveButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #1a73e8;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.saveButton:hover {\n  background: #1557b0;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);\n}\n\n.cancelButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #f1f3f4;\n  color: #5f6368;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancelButton:hover {\n  background: #e8eaed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChainApis_container__M6OeX`,
	"header": `ChainApis_header__kDhl3`,
	"headerSection": `ChainApis_headerSection__sCIzz`,
	"title": `ChainApis_title__05-aA`,
	"subtitle": `ChainApis_subtitle__eCZAt`,
	"createButton": `ChainApis_createButton__5QeG1`,
	"emptyState": `ChainApis_emptyState__SB3Wc`,
	"list": `ChainApis_list__0BAq3`,
	"chainCard": `ChainApis_chainCard__vlC7-`,
	"chainCardHeader": `ChainApis_chainCardHeader__obvrF`,
	"chainInfo": `ChainApis_chainInfo__D3vk3`,
	"chainName": `ChainApis_chainName__RlIqW`,
	"badges": `ChainApis_badges__wVIbW`,
	"stepBadge": `ChainApis_stepBadge__qt7eu`,
	"actions": `ChainApis_actions__sJKCY`,
	"headerActions": `ChainApis_headerActions__n1-8n`,
	"viewToggle": `ChainApis_viewToggle__IOUPh`,
	"viewToggleBtn": `ChainApis_viewToggleBtn__ifeGi`,
	"active": `ChainApis_active__7uDgQ`,
	"overlay": `ChainApis_overlay__4gbgJ`,
	"modal": `ChainApis_modal__EWkCW`,
	"modalWide": `ChainApis_modalWide__nlWtg`,
	"modalHeader": `ChainApis_modalHeader__Upfl8`,
	"closeBtn": `ChainApis_closeBtn__zaTR1`,
	"modalHeaderBar": `ChainApis_modalHeaderBar__dibe+`,
	"modalHeaderTop": `ChainApis_modalHeaderTop__Yq3iY`,
	"modalHeaderTitle": `ChainApis_modalHeaderTitle__0RXcE`,
	"modalHeaderSpacer": `ChainApis_modalHeaderSpacer__i2te-`,
	"chainNameInput": `ChainApis_chainNameInput__lUoIF`,
	"chainEnabledToggle": `ChainApis_chainEnabledToggle__y8vxI`,
	"modalBodySplit": `ChainApis_modalBodySplit__tasWj`,
	"modalFooter": `ChainApis_modalFooter__snZGn`,
	"cancelBtn": `ChainApis_cancelBtn__swgq6`,
	"saveBtn": `ChainApis_saveBtn__nglMy`,
	"treePane": `ChainApis_treePane__DwCcm`,
	"treePaneTitle": `ChainApis_treePaneTitle__scG3I`,
	"treeRoot": `ChainApis_treeRoot__X8zNF`,
	"treeChildren": `ChainApis_treeChildren__mLc1+`,
	"treeRow": `ChainApis_treeRow__2Z4m0`,
	"treeRowSelected": `ChainApis_treeRowSelected__JZNS0`,
	"treeRowEdgeActive": `ChainApis_treeRowEdgeActive__slx4C`,
	"treeRowLabel": `ChainApis_treeRowLabel__434kj`,
	"treeRowLabelRoot": `ChainApis_treeRowLabelRoot__2UqtH`,
	"treeRowUnset": `ChainApis_treeRowUnset__Lv709`,
	"treeRowChevronBtn": `ChainApis_treeRowChevronBtn__3-hU3`,
	"treeRowUrlTail": `ChainApis_treeRowUrlTail__7BE1X`,
	"treeRowUrlFull": `ChainApis_treeRowUrlFull__4dVei`,
	"treeLegend": `ChainApis_treeLegend__-CRVe`,
	"treeLegendRow": `ChainApis_treeLegendRow__+ckCY`,
	"treeEmptyHint": `ChainApis_treeEmptyHint__EiBYD`,
	"detailPane": `ChainApis_detailPane__shN5U`,
	"breadcrumb": `ChainApis_breadcrumb__bBR9S`,
	"breadcrumbCrumb": `ChainApis_breadcrumbCrumb__2tmVz`,
	"breadcrumbCrumbCurrent": `ChainApis_breadcrumbCrumbCurrent__VEgEW`,
	"breadcrumbSep": `ChainApis_breadcrumbSep__X1tLk`,
	"detailSection": `ChainApis_detailSection__P09M8`,
	"detailSectionHeader": `ChainApis_detailSectionHeader__987C4`,
	"detailNodeCard": `ChainApis_detailNodeCard__7gvJI`,
	"detailNodeCardManual": `ChainApis_detailNodeCardManual__GdL2j`,
	"detailNodeCardRoot": `ChainApis_detailNodeCardRoot__pfQtN`,
	"branchList": `ChainApis_branchList__uXL6H`,
	"branchRow": `ChainApis_branchRow__pKHhh`,
	"branchRowSelected": `ChainApis_branchRowSelected__aHCt9`,
	"branchRowBody": `ChainApis_branchRowBody__KWBnQ`,
	"branchRowTop": `ChainApis_branchRowTop__KKwQJ`,
	"branchRowBottom": `ChainApis_branchRowBottom__I+7I4`,
	"branchRowUrl": `ChainApis_branchRowUrl__SEk10`,
	"branchRowUnset": `ChainApis_branchRowUnset__RL380`,
	"branchRowMappingBadge": `ChainApis_branchRowMappingBadge__r1vnK`,
	"warn": `ChainApis_warn__Hb62i`,
	"branchRowDeleteBtn": `ChainApis_branchRowDeleteBtn__sTMYy`,
	"edgeHeader": `ChainApis_edgeHeader__Qpe81`,
	"edgeHeaderLabel": `ChainApis_edgeHeaderLabel__0g4Xf`,
	"edgeHeaderUrl": `ChainApis_edgeHeaderUrl__MTs2l`,
	"edgeMappingWrap": `ChainApis_edgeMappingWrap__GkDgb`,
	"edgeBackBtn": `ChainApis_edgeBackBtn__8aOca`,
	"emptyDetailState": `ChainApis_emptyDetailState__aMqTo`,
	"formGroup": `ChainApis_formGroup__i696p`,
	"selectedInfo": `ChainApis_selectedInfo__Hgj6s`,
	"methodTag": `ChainApis_methodTag__EQX1M`,
	"progressPass": `ChainApis_progressPass__OykS2`,
	"progressPassLabel": `ChainApis_progressPassLabel__DSUj8`,
	"progressPassCount": `ChainApis_progressPassCount__6gJfd`,
	"done": `ChainApis_done__qTWhu`,
	"partial": `ChainApis_partial__QStHE`,
	"pending": `ChainApis_pending__FYXLK`,
	"progressDivider": `ChainApis_progressDivider__zEHQO`,
	"progressHint": `ChainApis_progressHint__O3jv6`,
	"nodeNextBar": `ChainApis_nodeNextBar__1mo5r`,
	"nodeNextBtn": `ChainApis_nodeNextBtn__Pt2yK`,
	"edgeNextBar": `ChainApis_edgeNextBar__JPj5k`,
	"edgeNextLabel": `ChainApis_edgeNextLabel__45ANA`,
	"edgeNextBtn": `ChainApis_edgeNextBtn__RxHZJ`,
	"edgeDoneBadge": `ChainApis_edgeDoneBadge__wo62o`,
	"infoCallout": `ChainApis_infoCallout__DRBGj`,
	"info": `ChainApis_info__UftIh`,
	"infoCalloutIcon": `ChainApis_infoCalloutIcon__wf6+c`,
	"canvasNodeManual": `ChainApis_canvasNodeManual__2QDEL`,
	"manualBadge": `ChainApis_manualBadge__v-E4V`,
	"canvasManualToggle": `ChainApis_canvasManualToggle__sMBs9`,
	"canvasManualHint": `ChainApis_canvasManualHint__17SEf`,
	"canvasNodeMethod": `ChainApis_canvasNodeMethod__+kpyU`,
	"canvasNodeUrl": `ChainApis_canvasNodeUrl__-w+hp`,
	"canvasNodeLabel": `ChainApis_canvasNodeLabel__1RL+u`,
	"canvasNodeSub": `ChainApis_canvasNodeSub__kckyn`,
	"canvasNodeMeta": `ChainApis_canvasNodeMeta__bMKgk`,
	"canvasNodeDataList": `ChainApis_canvasNodeDataList__HzKUP`,
	"canvasNodeEmptyData": `ChainApis_canvasNodeEmptyData__eJqcb`,
	"canvasNodeStatus": `ChainApis_canvasNodeStatus__sFmZz`,
	"startIcon": `ChainApis_startIcon__6+U0S`,
	"successIcon": `ChainApis_successIcon__9G93P`,
	"errorIcon": `ChainApis_errorIcon__pR5u5`,
	"canvasArrow": `ChainApis_canvasArrow__1m0df`,
	"workflowBadge": `ChainApis_workflowBadge__mgD-G`,
	"canvasNameInput": `ChainApis_canvasNameInput__kW8yD`,
	"canvasToggle": `ChainApis_canvasToggle__LEMoD`,
	"canvasSelect": `ChainApis_canvasSelect__W7NVA`,
	"deleteBranchBtn": `ChainApis_deleteBranchBtn__VoNNL`,
	"saveButton": `ChainApis_saveButton__LNLag`,
	"cancelButton": `ChainApis_cancelButton__C2BUg`
};
export default ___CSS_LOADER_EXPORT___;
